export const getConsultList = (store) => store.consult.data;
export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.consult;
  return rest;
};
